module.exports = __webpack_public_path__ + "HappyCreditobanner-3-item.7789c02d.png";